import React from 'react';

function WhoWeAre() {
  const styles = {
    section: {
      position: 'relative', padding: '80px 48px 80px', background: '#fff', overflow: 'hidden'
    },
    headingRow: { display: 'flex', alignItems: 'center', gap: 16, marginBottom: 8 },
    heading: {
      fontFamily: 'Lato', fontWeight: 400, fontSize: '26px', lineHeight: '100%',
      letterSpacing: '-0.01em', textTransform: 'uppercase', color: '#000', margin: 0
    },
    headingLine: {
      width: 60, height: 4, background: '#E73123', flexShrink: 0
    },
    titleWrap: { marginBottom: 8 },
    titleRed: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '40px', lineHeight: '100%',
      letterSpacing: 0, textTransform: 'uppercase', color: '#E73123', display: 'inline'
    },
    titleBlack: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '40px', lineHeight: '100%',
      letterSpacing: 0, textTransform: 'uppercase', color: '#000', display: 'inline'
    },
    paragraph: {
      fontFamily: 'Lato', fontWeight: 400, fontSize: 16, lineHeight: '26px',
      letterSpacing: 0, color: '#838383', margin: '0 0 48px', width: '100%'
    },
    bottomRow: { display: 'flex', gap: 48, alignItems: 'stretch', flexWrap: 'wrap' },
    imageWrap: { flex: '1 1 360px', minWidth: 260 },
    image: {
      width: '100%', height: 'auto', objectFit: 'cover', borderRadius: 4
    },
    redBox: {
      flex: '1 1 360px', background: '#E73123', padding: 48, color: '#fff',
      display: 'flex', flexDirection: 'column', justifyContent: 'space-between'
    },
    redBoxText: {
      fontFamily: 'Lato', fontWeight: 400, fontSize: 16, lineHeight: '26px',
      letterSpacing: 0, margin: '0 0 24px'
    },
    learnMoreBtn: {
      display: 'inline-block', padding: '14px 32px', border: '2px solid #E73123',
      background: '#fff', color: '#E73123', textDecoration: 'none', fontFamily: 'Lato',
      fontWeight: 400, fontSize: '18px', textTransform: 'uppercase', alignSelf: 'flex-start'
    },
  };

  const paraText = "Is one of the leading and fastest-growing construction company focused on making our country infrastructure more efficient through building & integrating terrains and cityscapes. Sunrise's activity areas include construction of Residential & Commercial Buildings, Hotels, Schools & Colleges. Sunrise also has forayed in heavy civil infrastructure works which includes precast & cast in-situ piles, D Wall, & mass earth work.";

  const redBoxText = "Promoters of the company are qualified civil engineer. The Company has a dedicated team of engineers and supervisors for execution of various construction activities at sites with a Pan India presence.";

  return React.createElement('section', { style: styles.section },
    React.createElement('div', { style: styles.headingRow },
      React.createElement('h2', { style: styles.heading }, 'WHO WE ARE'),
      React.createElement('div', { style: styles.headingLine })
    ),
    React.createElement('div', { style: styles.titleWrap },
      React.createElement('div', null,
        React.createElement('span', { style: styles.titleRed }, 'SUNRISE '),
        React.createElement('span', { style: styles.titleBlack }, 'INFRABUILD')
      ),
      React.createElement('div', { style: { ...styles.titleBlack, display: 'block' } }, 'PVT LTD')
    ),
    React.createElement('p', { style: styles.paragraph }, paraText),
    React.createElement('div', { style: styles.bottomRow },
      React.createElement('div', { style: styles.imageWrap },
        React.createElement('img', {
          src: '/steelpipes.jpg',
          alt: 'Construction site',
          style: styles.image
        })
      ),
      React.createElement('div', { style: styles.redBox },
        React.createElement('p', { style: styles.redBoxText }, redBoxText),
        React.createElement('a', { href: '#', style: styles.learnMoreBtn }, 'LEARN MORE')
      )
    )
  );
}

export default WhoWeAre;
